export default __webpack_public_path__ + "static/media/ic_award.a5aa43a2.png";